import { Component, OnInit } from '@angular/core';
import { DestinationService } from '../../../core/services/destination.service';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { Pagination } from '../../../core/dto/pagination';
import { LoadingService } from '../../../core/services/loading.service';
import { SETTINGS } from '../../../core/config/common.settings';
import { DefaultContentsPageSize } from '../../../core/dto/defaultContentsPage.size';
import { NzModalService } from 'ng-zorro-antd/modal';
import { TranslocoService } from '@ngneat/transloco';

interface Destinations {
  createdAt: Date;
}

@Component({
  selector: 'app-destinations',
  templateUrl: './destinations.component.html',
  styleUrls: ['./destinations.component.scss'],
})
export class DestinationsComponent implements OnInit {
  isLoading = false;
  pageSize = new DefaultContentsPageSize();
  sortField: any;
  sortOrder: any;
  listOfData: any[] = [];
  searchName = '';

  sortColumn = {
    compare: (a: Destinations, b: Destinations) => {
      return (new Date(a.createdAt) as any) - (new Date(b.createdAt) as any);
    },
  };

  constructor(
    private destinationService: DestinationService,
    private loadingService: LoadingService,
    private modal: NzModalService,
    private translocoService: TranslocoService
  ) {}

  ngOnInit(): void {}

  onTableParamsChange(params: NzTableQueryParams): void {
    this.loadingService.start();
    this.pageSize.pageSize = params.pageSize;
    this.pageSize.pageIndex = params.pageIndex;
    const keyword = this.searchName;
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      keyword,
    });
    this.destinationService
      .getPagedDestinations(payload)
      .then((object: any) => {
        this.listOfData = object.data;
        this.pageSize.length = object.metadata[0]?.total;
        this.loadingService.stop();
      });
  }

  search(): void {
    this.loadingService.start();
    const keyword = this.searchName;
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      keyword,
    });
    this.destinationService
      .getPagedDestinations(payload)
      .then((object: any) => {
        this.listOfData = object.data;
        this.pageSize.length = object.metadata[0]?.total;
        this.loadingService.stop();
      });
  }

  reset(): void {
    this.loadingService.start();
    this.searchName = '';
    const keyword = this.searchName;
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      keyword,
    });
    this.destinationService
      .getPagedDestinations(payload)
      .then((object: any) => {
        this.listOfData = object.data;
        this.pageSize.length = object.metadata[0]?.total;
        this.loadingService.stop();
      });
  }

  showArchiveModal(id: string, customerName: string): void {
    this.modal.confirm({
      nzTitle: this.translocoService.translate('destinations.archiveModal.title'),
      nzContent: `${this.translocoService.translate('destinations.archiveModal.content')} ${customerName}?`,
      nzOkText: this.translocoService.translate('destinations.archiveModal.ok'),
      nzOkType: 'primary',
      nzOkDanger: true,
      nzOnOk: () => this.archiveDestination(id),
      nzCancelText: this.translocoService.translate('destinations.archiveModal.cancel'),
    });
  }

  async archiveDestination(id: string): Promise<void> {
    await this.destinationService.updateDestination({ _id: id, active: false });
    this.reset();
  }

  protected readonly SETTINGS = SETTINGS;
}
